<header class="topbar">
  <!-- backdrop to close open panels -->
  @if (notifOpen() || userMenuOpen || waffleOpen()) {
    <div class="topbar-backdrop" (click)="closeAll()"></div>
  }
  <!-- ── Left: Logos ──────────────────────────────────────────────── -->
  <div class="topbar__left">
    <!-- Waffle app launcher -->
    <div class="topbar__action-wrap pl-4">
      <button
        class="topbar__waffle-btn"
        (click)="toggleWaffle()"
        [class.topbar__waffle-btn--active]="waffleOpen()"
        aria-label="All apps"
        [attr.aria-expanded]="waffleOpen()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          viewBox="0 0 2048 2048"
        >
          <path d="M0 0h2048v2048H0z" fill="none" />
          <path
            fill="currentColor"
            d="M384 640V384h256v256zm512 0V384h256v256zm512-256h256v256h-256zM384 1152V896h256v256zm512 0V896h256v256zm512 0V896h256v256zM384 1664v-256h256v256zm512 0v-256h256v256zm512 0v-256h256v256z"
          />
        </svg>
      </button>
      @if (waffleOpen()) {
        <ec-waffle-menu (close)="waffleOpen.set(false)" />
      }
    </div>

    <a routerLink="/" class="topbar__eciso-logo m-2" aria-label="eCISO Home">
      <img
        src="assets/app-icons/eciso-logo.svg"
        alt="eCISO"
        class="topbar__eciso-img"
      />
    </a>
  </div>

  <!-- ── Right: Utilities ────────────────────────────────────────── -->
  <div class="topbar__right">
    <span
      class="custom-badge badge badge-danger badge-sm badge-outline w-auto sm:w-auto px-3 py-1 truncate text-center h-30px text-nowrap mr-2"
    >
      Security Score
      <span class="text-md font-semibold ms-1"
        >{{ aggregatedCount || 0 | number: "1.2-2" }}%</span
      >
    </span>

    <!-- <ec-search-bar /> -->

    <!-- Notifications -->
    <div class="topbar__action-wrap">
      <button
        class="topbar__icon-btn"
        (click)="toggleNotifs($event)"
        [class.topbar__icon-btn--active]="notifOpen()"
        aria-label="Notifications"
        [title]="'Notifications'"
        [attr.aria-expanded]="notifOpen()"
      >
        <img
          src="assets/icons/ui/bell.svg"
          alt="Notifications"
          width="18"
          height="18"
        />
        @if (unread > 0) {
          <span class="topbar__badge">{{ unread > 9 ? "9+" : unread }}</span>
        }
      </button>

      @if (notifOpen()) {
        <ec-notification-panel (close)="notifOpen.set(false)" />
      }
    </div>

    <!-- Theme toggle -->
    <button
      class="topbar__icon-btn"
      (click)="toggleTheme()"
      [attr.aria-label]="
        isDark ? 'Switch to light mode' : 'Switch to dark mode'
      "
      [title]="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
    >
      @if (isDark) {
        <img src="assets/icons/ui/sun.svg" alt="" width="18" height="18" />
      } @else {
        <img src="assets/icons/ui/moon.svg" alt="" width="18" height="18" />
      }
    </button>

    <!-- Bookmark Toggle -->
    <div class="topbar__action-wrap">
      <button
        class="topbar__icon-btn"
        (click)="toggleBookmarkMenu($event)"
        [class.topbar__icon-btn--active]="bookmarkMenuOpen()"
        aria-label="Bookmarks"
        [title]="'Bookmarks'"
        [attr.aria-expanded]="bookmarkMenuOpen()"
      >
        <img src="assets/icons/ui/bookmark.svg" alt="" width="18" height="18" />
      </button>

      @if (bookmarkMenuOpen()) {
        <div
          class="bookmark-dropdown bg-white dark:bg-coal-500 border border-gray-300 dark:border-gray-700"
          (click)="$event.stopPropagation()"
        >
          <div class="bookmark-dropdown__header">
            <span>Bookmarks</span>
            @if (isBookmarkWriteAccess) {
              <button
                class="bookmark-dropdown__add-btn"
                (click)="openAddBookmarkModal($event)"
              >
                <span class="plus-icon">+</span> Add Bookmark
              </button>
            }
          </div>

          <div class="bookmark-dropdown__content">
            @if (bookmarksLoading) {
              <div class="bookmark-dropdown__loading">
                <div class="bookmark-spinner"></div>
              </div>
            } @else if (!bookmarks || bookmarks.length === 0) {
              <div class="bookmark-dropdown__empty text-gray-800">
                No bookmarks found
              </div>
            } @else {
              <div class="bookmark-dropdown__list">
                @for (item of bookmarks; track item._id) {
                  <div
                    class="bookmark-dropdown__item"
                    (click)="navigateBookmark(item, $event)"
                  >
                    <img
                      [src]="getFavicon(item.link)"
                      (load)="onFaviconLoad($event, item.link)"
                      (error)="onFaviconError($event, item.link)"
                      class="bookmark-dropdown__favicon"
                      alt=""
                    />
                    <div class="bookmark-dropdown__item-info">
                      <div class="bookmark-dropdown__item-title">
                        {{ item.name }}
                      </div>
                      <div class="bookmark-dropdown__item-link">
                        {{ item.link }}
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>

    <!-- <div class="topbar__divider" aria-hidden="true"></div> -->

    <!-- User avatar / menu -->
    <div class="menu" data-menu="true" (click)="$event.stopPropagation()">
      <div
        class="menu-item"
        [class.show]="userMenuOpen"
        style="position: relative"
      >
        <div
          class="menu-toggle flex items-center justify-center cursor-pointer rounded-full"
          (click)="toggleUserMenu()"
        >
          <img
            [src]="
              profilePhotoUrl || './assets/media/icons/default-user-icon.png'
            "
            alt="Profile Photo"
            class="w-7 h-7 rounded-full object-cover ring-1 ring-white shrink-0"
            (error)="handleImageError($event)"
          />
        </div>
        <div
          class="menu-dropdown menu-default light:border-gray-300 w-[250px] bg-white dark:bg-coal-500"
          [class.show]="userMenuOpen"
          [style.display]="userMenuOpen ? 'flex' : 'none'"
          style="
            position: absolute;
            right: 0;
            top: 100%;
            z-index: 105;
            margin-top: 10px;
          "
        >
          <div class="flex items-center justify-between px-5 py-1.5 gap-1.5">
            <div class="flex items-center gap-2">
              <div
                routerLink="/eciso/my-profile"
                (click)="closeAll()"
                class="cursor-pointer shrink-0"
              >
                <img
                  [src]="
                    profilePhotoUrl ||
                    './assets/media/icons/default-user-icon.png'
                  "
                  alt="Profile Photo"
                  class="w-9 h-9 rounded-full object-cover ring-1 ring-white shrink-0"
                  (error)="handleImageError($event)"
                />
              </div>
              <div class="flex flex-col gap-1.5">
                <span class="text-sm text-gray-800 font-semibold leading-none">
                  {{ profileResponse?.name }}
                </span>
                <a
                  class="text-xs text-gray-600 hover:text-primary font-medium leading-none text-wraps"
                >
                  {{ profileResponse?.email }}
                </a>
              </div>
            </div>
            <!-- <span class="badge badge-xs badge-primary badge-outline">
                                Pro
                            </span> -->
          </div>
          <div class="menu-separator"></div>

          <div class="flex flex-col">
            <!-- <div class="menu-item mb-0.5">
              <div class="menu-link">
                <span class="menu-icon">
                  <i class="ki-filled ki-moon"> </i>
                </span>
                <span class="menu-title"> Light Mode </span>
                <label class="switch switch-sm">
                  <input
                    data-theme-state="light"
                    data-theme-toggle="true"
                    name="check"
                    type="checkbox"
                    value="1"
                    (change)="onDarkModeToggle()"
                  />
                </label>
              </div>
            </div> -->

            <div class="menu-item">
              <a class="menu-link" (click)="openTerms()">
                <span class="menu-icon">
                  <i class="ki-filled ki-questionnaire-tablet"> </i>
                </span>
                <span class="menu-title"> Terms & Conditions </span>
              </a>
            </div>
            <div class="menu-item">
              <a
                class="menu-link"
                (click)="contactSupport()"
                href="mailto:support@eciso.app"
              >
                <span class="menu-icon">
                  <i class="ki-filled ki-sms"> </i>
                </span>
                <span class="menu-title"> Contact Support </span>
              </a>
            </div>
            <span
              class="relative text-gray-700 text-xs mx-6 flex justify-center mt-2"
              >Version :
              {{
                (version?.displayVersion || version?.version) && version.build
                  ? (version.displayVersion || version.version) +
                    " : " +
                    version.build
                  : "1.0.0 : 0"
              }}</span
            >

            <div class="menu-item px-4 py-1.5">
              <a class="btn btn-sm btn-light justify-center" (click)="logout()">
                Log out
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="topbar__logo-divider" aria-hidden="true"></div> -->

    @if (orgProfilePhotoUrl && !isOrgLogoBroken) {
      <a
        (click)="openEditLogoModal(); $event.preventDefault()"
        class="topbar__company-logo cursor-pointer"
      >
        <img
          [src]="orgProfilePhotoUrl"
          alt="Company logo"
          (error)="handleOrgLogoError()"
          [style.width.px]="companyLogo.width"
          [style.height.px]="companyLogo.height"
        />
      </a>
    } @else {
      <a
        (click)="openEditLogoModal(); $event.preventDefault()"
        class="topbar__company-logo topbar__company-logo--placeholder cursor-pointer"
        title="Upload your company logo"
      >
        <span>+ Company Logo</span>
      </a>
    }
  </div>
</header>

<div
  class="modal items-center justify-center py-6 px-4"
  id="topbar_profile_modal"
  style="z-index: 1055 !important"
  (click)="closeOnBackdropClick($event)"
>
  <div
    class="modal-content bg-white dark:bg-coal-500"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-header pr-2.5">
      <span class="text-base font-semibold card-title">
        {{ modalTitle }}
      </span>
      <button
        class="btn btn-sm btn-icon btn-light btn-clear shrink-0"
        (click)="closeModal()"
      >
        <i class="ki-filled ki-cross"> </i>
      </button>
    </div>
    <div class="modal-body grid gap-5 px-0">
      <app-modal-renderer
        #modalRenderRef
        [nodeId]="activeModalContext?.nodeId"
        (header)="setModalTitle($event)"
        [isHeader]="true"
        (closeModal)="closeModal()"
        [disableFields]="true"
        [activeModalContext]="activeModalContext"
      ></app-modal-renderer>
    </div>
  </div>
</div>

<!-- Settings modal -->
<div
  class="modal items-center justify-center py-6 px-4"
  id="topbar_modal_settings"
  style="z-index: 1055 !important"
  (click)="closeSettingsOnBackdropClick($event, 'topbar_modal_settings')"
>
  <div
    class="modal-content w-[95vw] max-w-7xl my-5 mx-auto sm:rounded-lg shadow-lg max-h-[85vh] bg-white dark:bg-coal-500"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-header flex justify-between items-center p-4 border-b">
      <span class="text-base font-semibold card-title ms-5"> Settings </span>
      <button
        class="btn btn-sm btn-icon btn-light btn-clear shrink-0"
        (click)="closeSettingsModal('topbar_modal_settings')"
      >
        <i class="ki-filled ki-cross"> </i>
      </button>
    </div>
    <div
      class="modal-body gap-5 overflow-y-auto flex-1"
      style="height: 690px; max-height: 700px"
    >
      <app-settings></app-settings>
    </div>
  </div>
</div>

<!-- Edit Company Logo Modal -->
<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  id="logo_photo_modal"
  [class.show]="showEditLogoModal"
>
  <div
    class="modal-content w-full max-w-[450px] sm:rounded-lg shadow-lg bg-white dark:bg-coal-500"
  >
    <!-- Modal Header -->
    <div class="modal-header pr-2.5">
      <span class="font-semibold text-base ms-2 card-title"
        >Edit Company Logo</span
      >
    </div>

    <!-- Modal Body -->
    <div class="modal-body p-6 flex flex-col gap-4">
      <!-- Subtext description -->
      <p class="text-xs text-gray-500 dark:text-gray-400 -mt-2">
        Update your company logo. PNG, JPG, JPEG or SVG formats are supported.
      </p>

      <!-- Unified Upload & Preview Card -->
      <div
        class="logo-upload-card"
        [class.dragover]="isLogoDragOver"
        (click)="triggerLogoFileInput()"
        (dragover)="onLogoDragOver($event)"
        (dragleave)="onLogoDragLeave()"
        (drop)="onLogoFileDropped($event)"
      >
        <!-- State A: Logo is present (staged or active) -->
        <ng-container
          *ngIf="stagedLogoUrl || (orgProfilePhotoUrl && !isOrgLogoBroken)"
        >
          <div
            class="relative w-full max-w-[160px] h-[100px] flex items-center justify-center p-2 bg-white dark:bg-coal-700 rounded-lg border border-gray-200 dark:border-coal-400 shadow-sm transition-transform duration-200 hover:scale-[1.02]"
          >
            <!-- Staged image -->
            <img
              *ngIf="stagedLogoUrl"
              [src]="stagedLogoUrl"
              alt="New Logo Preview"
              style="
                max-width: 140px;
                max-height: 64px;
                width: auto;
                height: auto;
                object-fit: contain;
                display: block;
              "
            />
            <!-- Current logo -->
            <img
              *ngIf="!stagedLogoUrl"
              [src]="orgProfilePhotoUrl"
              alt="Current Company Logo"
              style="
                max-width: 140px;
                max-height: 64px;
                width: auto;
                height: auto;
                object-fit: contain;
                display: block;
              "
              (error)="handleOrgLogoError()"
            />
          </div>

          <div class="mt-4 flex flex-col items-center gap-1.5 text-center">
            <span
              class="text-xs font-semibold text-primary dark:text-primary-active flex items-center gap-1.5"
            >
              <i class="ki-outline ki-file-up text-sm"></i>
              Click or drag to replace
            </span>
            <!-- <button
              type="button"
              class="btn btn-xs btn-light btn-active-light-danger mt-1 flex items-center gap-1"
              (click)="removeSelectedLogo($event)"
            >
              <i class="ki-outline ki-trash text-xs"></i>
              Remove Logo
            </button> -->
          </div>
        </ng-container>

        <!-- State B: No Logo (Empty state upload zone) -->
        <ng-container
          *ngIf="!stagedLogoUrl && (!orgProfilePhotoUrl || isOrgLogoBroken)"
        >
          <div class="flex flex-col items-center text-center py-2">
            <div
              class="w-10 h-10 rounded-full bg-gray-100 dark:bg-coal-500 flex items-center justify-center mb-3"
            >
              <i
                class="ki-outline ki-file-up text-lg text-gray-500 dark:text-gray-400"
              ></i>
            </div>
            <p class="text-sm font-medium text-gray-700 dark:text-gray-200">
              Drag and drop your logo here
            </p>
            <p class="text-xs text-gray-400 mt-1 mb-2.5">or</p>
            <button type="button" class="photo-modal-choose-btn">
              Choose File
            </button>
          </div>
        </ng-container>
      </div>

      <!-- Hidden Input for file selection inside Modal -->
      <input
        #modalLogoFileInput
        type="file"
        (change)="onLogoFileSelected($event)"
        accept=".png,.jpg,.jpeg,.svg"
        class="hidden"
      />

      <!-- Helper Text below Upload Area -->
      <p class="photo-modal-helper-text">
        Max size of 2MB. Recommended size: 400x400 px
      </p>

      <!-- Cancel & Save Row -->
      <div class="photo-modal-footer">
        <button
          type="button"
          class="photo-modal-btn-cancel cancel-modal-btn"
          (click)="closeEditLogoModal()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="photo-modal-btn-save"
          [disabled]="isLogoUploading"
          (click)="saveLogo()"
        >
          <div *ngIf="isLogoUploading" class="photo-modal-spinner"></div>
          <span>Save Logo</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Bookmark Modal -->
<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  [id]="'open_modal_' + (activeBookmarkModalContext?.nodeId || 'default')"
  (click)="closeBookmarkModalOnBackdropClick($event)"
>
  <div
    class="modal-content mx-auto my-5 w-full max-w-[700px] sm:rounded-lg shadow-lg bg-white dark:bg-coal-500"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-header flex justify-between items-center p-4 border-b">
      <span class="text-base font-semibold card-title">
        {{ bookmarkModalTitle || "Add Bookmark" }}
      </span>
      <button
        class="btn btn-sm btn-icon btn-light btn-clear shrink-0"
        (click)="closeBookmarkModal()"
      >
        <i class="ki-filled ki-cross"> </i>
      </button>
    </div>
    <div class="modal-body gap-5 p-4" *ngIf="activeBookmarkModalContext">
      <app-modal-renderer
        #bookmarkModalRendererRef
        [nodeId]="activeBookmarkModalContext?.nodeId"
        [activeModalContext]="activeBookmarkModalContext"
        [disableFields]="false"
        (header)="setBookmarkModalTitle($event)"
        (closeModal)="closeBookmarkModal()"
        (formSaved)="onBookmarkModalFormSaved($event)"
        [recordIDs]="activeBookmarkModalContext?.recordID"
        (formReady)="openCurrentBookmarkModal()"
      ></app-modal-renderer>
    </div>
  </div>
</div>
